import React from 'react';

import { useTranslation } from '@crehana/i18n';

const PaymentTerms: React.FC<{ className?: string }> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <p
      className={`font-legals text-base-main md:text-secondary-dark ${className}`}
    >
      {t('TERMS_CONDITIONS_DESCRIPTION')}
    </p>
  );
};

export default PaymentTerms;
